<template>
  <div v-if="alertType === 'failed' || alertType === 'error'" class="toast-container failed">
    <div class="alert-icon">
      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6964_6597)">
          <path
            d="M26.6146 24.3065C20.4586 18.1525 14.3021 11.9955 8.1451 5.83848C5.4046 3.09798 2.6001 5.90298 5.3411 8.64348L23.8086 27.112C26.5501 29.854 29.3536 27.048 26.6146 24.3065Z"
            fill="#8B182C" />
          <path
            d="M15.9804 0.5C7.17141 0.5 0.00390625 7.6675 0.00390625 16.4765C0.00390625 25.2855 7.17141 32.453 15.9804 32.453C24.7889 32.453 31.9564 25.2855 31.9564 16.4765C31.9564 7.6675 24.7889 0.5 15.9804 0.5ZM15.9804 28.493C9.35391 28.493 3.96541 23.103 3.96541 16.478C3.96541 9.853 9.35591 4.458 15.9804 4.458C22.6074 4.458 27.9954 9.8495 27.9954 16.478C27.9954 23.1065 22.6054 28.493 15.9804 28.493Z"
            fill="#BE1E2D" />
          <path
            d="M2.3515 16.4765C2.3515 8.064 8.8915 1.1655 17.153 0.56C16.763 0.5315 16.3735 0.5 15.9765 0.5C7.1675 0.5 0 7.6675 0 16.4765C0 25.2855 7.1675 32.453 15.9765 32.453C16.373 32.453 16.763 32.422 17.153 32.393C8.8915 31.7875 2.3515 24.888 2.3515 16.4765ZM17.155 28.4335C17.5456 28.4725 17.9379 28.4924 18.3305 28.493C24.9565 28.493 30.3455 23.103 30.3455 16.478C30.3455 9.853 24.955 4.458 18.3305 4.458C17.934 4.458 17.542 4.4795 17.155 4.518C23.23 5.111 27.996 10.246 27.996 16.476C27.996 22.706 23.2305 27.84 17.1555 28.433"
            fill="#8B182C" />
        </g>
        <defs>
          <clipPath id="clip0_6964_6597">
            <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="message-box">
      <span>Error</span>
      <p>{{ alertMessage }}</p>
    </div>
    <!-- <div class="action-box">
      <button @click="closeAlert" class="close-alert-button">Close</button>
    </div> -->
  </div>
  <div v-if="alertType === 'warning'" class="toast-container warning">
    <div class="alert-icon">
      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6963_5614)">
          <path
            d="M31.6844 27.2601C26.9904 18.6851 22.2944 10.11 17.5994 1.53505C17.4428 1.23829 17.2083 0.98988 16.9209 0.816605C16.6336 0.64333 16.3044 0.551758 15.9689 0.551758C15.6334 0.551758 15.3042 0.64333 15.0169 0.816605C14.7296 0.98988 14.495 1.23829 14.3384 1.53505C9.64391 10.11 4.94541 18.6851 0.253412 27.2601C-0.473088 28.5846 0.452912 30.3016 1.88241 30.3016H30.0574C30.8494 30.3016 31.3814 29.875 31.6589 29.2966C32.0079 28.7456 32.1014 28.0141 31.6864 27.2591"
            fill="#FFDD15" />
          <path
            d="M14.4581 17.7384L14.0136 11.1074C13.9306 9.81594 13.8906 8.88794 13.8906 8.32494C13.8906 7.55794 14.0906 6.96144 14.4916 6.53094C14.8941 6.10294 15.4231 5.88794 16.0791 5.88794C16.8706 5.88794 17.4021 6.16344 17.6681 6.71094C17.9366 7.26194 18.0726 8.05294 18.0726 9.08644C18.0726 9.69394 18.0396 10.3129 17.9736 10.9404L17.3786 17.7649C17.3141 18.5779 17.1766 19.2009 16.9651 19.6344C16.7521 20.0699 16.4011 20.2849 15.9106 20.2849C15.4146 20.2849 15.0656 20.0754 14.8746 19.6564C14.6781 19.2359 14.5406 18.5964 14.4581 17.7384ZM15.9941 26.8469C15.4316 26.8469 14.9411 26.6659 14.5206 26.3004C14.1001 25.9364 13.8906 25.4264 13.8906 24.7714C13.8906 24.1999 14.0906 23.7114 14.4916 23.3109C14.8941 22.9079 15.3846 22.7079 15.9671 22.7079C16.5496 22.7079 17.0436 22.9079 17.4556 23.3109C17.8631 23.7114 18.0726 24.1999 18.0726 24.7714C18.0726 25.4164 17.8631 25.9254 17.4496 26.2934C17.0521 26.6557 16.5319 26.8535 15.9941 26.8469Z"
            fill="#1F2E35" />
        </g>
        <defs>
          <clipPath id="clip0_6963_5614">
            <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>

    </div>
    <div class="message-box">
      <span>Peringatan</span>
      <p>{{ alertMessage }}</p>
    </div>
    <!-- <div class="action-box">
      <button @click="closeAlert" class="close-alert-button">Close</button>
    </div> -->
  </div>
  <div v-if="alertType === 'normal'" class="toast-container success">
    <div class="alert-icon">
      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.3671 3.04057C24.1486 6.69157 20.5796 10.1671 17.3121 14.7016C15.8711 16.7016 14.2686 19.0556 13.2211 21.2781C12.6231 22.4566 11.5451 24.2981 11.1776 26.0686C9.16763 24.1986 7.00863 22.0761 4.79963 20.4136C3.22513 19.2291 -1.30987 21.6441 0.536132 23.0331C3.84463 25.5216 6.59613 28.6211 9.81413 31.2206C11.1601 32.3066 14.1431 29.9481 14.8441 28.9586C17.1451 25.6986 17.4596 21.7136 19.1366 18.1576C21.6971 12.7191 26.2381 8.25157 30.7216 4.37207C33.6921 1.60157 30.6241 1.09057 28.3716 3.04057" fill="#37B34A"/>
      </svg>
    </div>
    <div class="message-box">
      <span>Berhasil</span>
      <p>{{ alertMessage }}</p>
    </div>
    <!-- <div class="action-box">
      <button @click="closeAlert" class="confirm-alert-button">TUTUP</button>
    </div> -->
  </div>
  <div v-if="alertType === 'info'" class="toast-container info">
    <div class="alert-icon">
      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6966_2577)">
          <path d="M15.9455 0.5C7.1535 0.5 0 7.6535 0 16.4455C0 25.2375 7.1535 32.391 15.9455 32.391C24.7375 32.391 31.891 25.2375 31.891 16.4455C31.891 7.6535 24.7375 0.5 15.9455 0.5ZM15.9455 28.4385C9.332 28.4385 3.9525 23.0585 3.9525 16.4455C3.9525 9.832 9.332 4.4515 15.9455 4.4515C22.559 4.4515 27.9385 9.832 27.9385 16.4455C27.9385 23.0585 22.5585 28.4385 15.9455 28.4385Z" fill="#1B75BB"/>
          <path d="M15.9684 9.4594C15.4179 9.4594 14.9434 9.2909 14.5504 8.9529C14.1574 8.6139 13.9614 8.1334 13.9614 7.5124C13.9614 6.9499 14.1614 6.4864 14.5644 6.1239C14.9669 5.7594 15.4354 5.5769 15.9684 5.5769C16.4819 5.5769 16.9394 5.7409 17.3364 6.0719C17.7324 6.4014 17.9329 6.8824 17.9329 7.5124C17.9329 8.1239 17.7379 8.5994 17.3499 8.9464C16.9619 9.2889 16.5014 9.4594 15.9684 9.4594ZM17.9329 13.5634V25.0419C17.9329 25.8369 17.7419 26.4384 17.3644 26.8459C16.9879 27.2519 16.5069 27.4564 15.9249 27.4564C15.3429 27.4564 14.8684 27.2489 14.5059 26.8314C14.1414 26.4139 13.9609 25.8174 13.9609 25.0419V13.6809C13.9609 12.8949 14.1414 12.3024 14.5059 11.9054C14.8684 11.5069 15.3429 11.3109 15.9249 11.3109C16.5069 11.3109 16.9879 11.5069 17.3644 11.9054C17.7419 12.3019 17.9329 12.8569 17.9329 13.5634Z" fill="#1B75BB"/>
        </g>
        <defs>
          <clipPath id="clip0_6966_2577">
            <rect width="32" height="32" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
        </defs>
      </svg>

    </div>
    <div class="message-box">
      <span>Info</span>
      <p>{{ alertMessage }}</p>
    </div>
    <!-- <div class="action-box">
      <button @click="closeAlert" class="confirm-alert-button">TUTUP</button>
    </div> -->
  </div>

  <div class="Home" v-if="alertType === 'normalCallback' || alertType === 'confirmation'">
    <Card v-if="alertType === 'normalCallback'" class="card-container">
      <div class="alert-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 50 50">
          <path id="success-icon"
            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.25 8.891l-1.421-1.409-6.105 6.218-3.078-2.937-1.396 1.436 4.5 4.319 7.5-7.627z" />
        </svg>
        <div class="message-box">
          <span>Berhasil</span>
          <p>{{ alertMessage }}</p>
        </div>
      </div>
      <div class="action-box">
        <button @click="$store.getters.getAlertCallback" class="confirm-alert-button">
          TUTUP
        </button>
      </div>
    </Card>
    <Card v-if="alertType === 'confirmation'" class="card-container">
      <div class="alert-icon">
        <div class="message-box">
          <p>{{ alertMessage }}</p>
        </div>
      </div>
      <div class="action-box">
        <button @click="$store.getters.getAlertCallback" class="confirm-alert-button">
          Ya
        </button>
        <button @click="closeAlert" class="close-alert-button">Batal</button>
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/CardBlank.vue'

export default {
  name: 'AlertComponents',
  components: {
    Card
  },
  computed: {
    alertMessage () {
      return this.$store.getters.getAlertMessage
    },
    alertType () {
      return this.$store.getters.getAlertType
    }
  },
  mounted () {
    if (this.alertType && (this.alertType !== 'normalCallback' && this.alertType !== 'confimartion')) {
      setTimeout(() => {
        this.closeAlert()
      }, 5000)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/Layout/home.scss";
@import "../assets/scss/Components/Alert.scss";

button {
  cursor: pointer;
}

.Home {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 101;
  left: 0;
  right: 0;
  overflow: hidden !important;
  background-color: rgba(0, 0, 0, 0.3);

  .alert-icon {
    // justify-content: center;
    display: flex;

    .message-box {
      padding: 0rem 1rem;

      span {
        place-self: center;
        font-size: 24px;
        font-weight: 600;
      }

      p {
        font-weight: 500;
        font-size: 16px;
      }
    }
  }

  .action-box {
    margin-top: 0.6rem;
    display: flex;
    justify-content: center;

    .close-alert-button {
      padding: 0.4rem;
      border: none;
      outline: none;
      text-transform: uppercase;
      border-radius: 6px;
      // background-color: transparent;
      min-width: 100px;
      color: $red;
      font-weight: 600;
      margin-left: 20px;
    }

    .confirm-alert-button {
      padding: 0.4rem;
      min-width: 100px;
      border: none;
      outline: none;
      text-transform: uppercase;
      border-radius: 6px;
      background-color: $blue;
      color: $white;
      font-weight: 600;
    }
  }
}

.resend-verif {
  text-align: center;
}

.enable-resend {
  cursor: pointer;
  color: $blue;
  font-weight: 600;
}

#success-icon {
  height: 50px;
  width: 50px;
  transform: scale(2);
  fill: #6fd08c;
}
</style>
